import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=5fcb06ca&scoped=true"
import script from "./customerInfo.vue?vue&type=script&lang=js"
export * from "./customerInfo.vue?vue&type=script&lang=js"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=5fcb06ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb06ca",
  null
  
)

export default component.exports